import * as React from "react"
import { Popover as PopoverPrimitive } from "@base-ui/react/popover"

import { nativeButtonFor } from "@/components/ui/as-child"
import { cn } from "@/lib/utils"

function Popover({ ...props }: React.ComponentProps<typeof PopoverPrimitive.Root>) {
  return <PopoverPrimitive.Root data-slot="popover" {...props} />
}

type PopoverTriggerProps = React.ComponentProps<typeof PopoverPrimitive.Trigger> & {
  asChild?: boolean
}

function PopoverTrigger({ asChild, children, ...props }: PopoverTriggerProps) {
  if (!asChild) {
    return (
      <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props}>
        {children}
      </PopoverPrimitive.Trigger>
    )
  }
  const child = React.Children.only(children) as React.ReactElement
  return (
    <PopoverPrimitive.Trigger
      data-slot="popover-trigger"
      nativeButton={nativeButtonFor(child)}
      render={child}
      {...props}
    />
  )
}

function PopoverContent({
  className,
  positionerClassName,
  align = "center",
  side,
  sideOffset = 4,
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Popup> & {
  /** Classe do elemento posicionador (onde vive o z-index do popover). */
  positionerClassName?: string
  align?: "start" | "center" | "end"
  side?: "top" | "bottom" | "left" | "right"
  sideOffset?: number
}) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Positioner
        align={align}
        side={side}
        sideOffset={sideOffset}
        className={cn("z-[1300]", positionerClassName)}
      >
        <PopoverPrimitive.Popup
          data-slot="popover-content"
          className={cn(
            "w-72 origin-[var(--transform-origin)] rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-hidden transition-[opacity,transform] duration-150 data-starting-style:opacity-0 data-starting-style:scale-95 data-ending-style:opacity-0 data-ending-style:scale-95",
            className,
          )}
          {...props}
        />
      </PopoverPrimitive.Positioner>
    </PopoverPrimitive.Portal>
  )
}

export { Popover, PopoverTrigger, PopoverContent }
